const PLURAL_PARTICIPANTS = {
  Adult: 'Adults',
  Children: 'Children',
  Senior: 'Seniors',
  Teen: 'Teens',
  Infant: 'Infants',
  Universal: 'Universals',
  Person: 'Persons'
};

export { PLURAL_PARTICIPANTS };
